const leukoplakia =

[

    {label:"Size (cm)",
    controlType:"text",
    options:[]
    },

    {label:"Colour(s):",
    controlType:"checkbox group",
    options:["Red", "White"]
    },

    {label:"Uniformity:",
    controlType:"radio button",
    options:["Homogenous", "Heterogenous"]
    },

    {label:"Features",
    controlType:"checkbox group",
    options:["Nodules","Pebbling", "Ulceration","Increased firmness", "Bleeding"]
    },


    {label:"Features suggesting",
    controlType:"checkbox group",
    options:["Proliferative verrucous leukoplakia ", " Oral hairy leukoplakia"]
    },

   {label: "Side of mouth",
    controlType:"radio button",
    options:["Right", "Left", "Central"]
    },

    {label:"Area involved",
    controlType:"checkbox group",
    options:["Upper lip", "Lower lip", "Lower gum", "Upper Gum", "Inner cheek", "Palatte", "Anterior tongue", "Posterior tongue", "mouth floor", "Tonsil", "Oropharynx"]
    },


    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    


    
]

export default leukoplakia